<div class='verification-box'>
    <img class="closebutton m-t-5" alt="Close" (click)="closeDialog()">


    <div class="header">
        <h3>Verify Phone Number </h3>
    </div>
    <!-- <hr> -->
    <div class="otp-form">
        <form (ngSubmit)="onOTPFormSubmit()" [formGroup]="form" class=" text-center">
            <p class="f-12">Enter the code sent to the "<b>{{data.mobile}}</b>"" </p>
            <div class="row d-flex justify-content-between ">
                <div class="form-group " *ngFor="let input of formInput;  index as i">
                    <input #formRow type="text" formControlName="{{input}}" class="form-control" maxlength="1"
                        [class.invalidOTp]="verifyOTPError " (keyup)="keyUpEvent($event, i)">
                </div>
            </div>
            <div class="resend">
                <p>Didn't get otp? <a class="pointer" (click)="resendOtp()">Resend OTP</a></p>
            </div>

            <mat-error>{{verifyOTPErrorMsg}}</mat-error>
            <button type="submit" class="send-button m-t-30" [disabled]="form.invalid">Verify Phone Number</button>

        </form>


    </div>


</div>
